import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Box, CircularProgress } from "@mui/material";
import Footer from "../User/Footer";
import Navbar from "../User/Navbar";

export default function NotifactionView() {
  const { _id } = useParams(); // route param
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchData() {
      try {
        const res = await fetch(
          `https://msdskserver.onrender.com/api/notifaction/${_id}`
        );
        const result = await res.json();
        setData(result.data);
      } catch (error) {
        console.error("Error loading notification", error);
      } finally {
        setLoading(false);
      }
    }

    fetchData();
  }, [_id]);

  if (loading) {
    return (
      <Box sx={{ textAlign: "center", mt: 0 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!data) {
    return (
      <Box sx={{ textAlign: "center", mt: 0 }}>
        <h3>Notification not found</h3>
      </Box>
    );
  }

  return (
    <>
        <Navbar />
        <Box className="notice-wrapper">
          <div className="card">
              <div className="p-3">
                <h2>{data.titlename}</h2>

            <p style={{ color: "gray", fontSize: "14px" }}>
                Category: {data.category}
            </p>
              </div>

            <hr />

            {/* 🔥 HTML CONTENT RENDER */}
           <Box className="notice-wrapperr">
            <div
              className="notice-content"
              dangerouslySetInnerHTML={{ __html: data.content }}
            />
            </Box>
          </div>
        </Box>
        <Footer/>
    </>
  );
}
